import axios from 'axios'
import { baseurl } from './constants/globalconstants';
import store from '../../store';
import { storeAccessToken } from '../../action';
import { navigateTo } from "./NavigateService";
 
const axiosInstance = axios.create({
    baseURL : baseurl,
    headers : {
             "Content-Type": "application/json",
         },
});

let getNewAccessToken = null;

export const setAuthTokenRefresher = (refreshFunc) => {
    getNewAccessToken = refreshFunc;
}
 
axiosInstance.interceptors.request.use(config => {
    const state = store.getState();
    let token = state.storetoken;

    if (token) { config.headers.Authorization = `Bearer ${token}` };
    return config;
}, error => { return Promise.reject(error) }
);
 
axiosInstance.interceptors.response.use(
    async(response) => {
        return response;
    },
    async(error) => {
    console.error('API Error:', error.response);
    const originalRequest = error.config;
         const isTokenExpired = error.response?.status === 401 && error.response.data.httpStatus == "UNAUTHORIZED" && error.response.data.Message == "Access Token expired" && !originalRequest._retry;
         const isUnAuthorised = error.response?.status === 401 && error.response.data.httpStatus == "UNAUTHORIZED" && error.response.data.Message == "UnAuthorize User Role"
        if (isTokenExpired) {
             try {
                 originalRequest._retry = true;
                 const newToken = await getNewAccessToken();
                 store.dispatch(storeAccessToken(newToken));
                 originalRequest.headers.Authorization = `Bearer ${newToken}`;
                 return axiosInstance(originalRequest);
             }
             catch (refreshErr) {
                 console.error('Token refresh failed in response interceptor:', refreshErr);
                 return Promise.reject(refreshErr);
             }
         }

        if (isUnAuthorised) {
            navigateTo("/Error403Page");
        }
    return Promise.reject(error);
});

export default axiosInstance;
